import { useTranslation } from 'react-i18next'
import Input from "components/common/Input/Input"
import InputError from "components/common/InputError/InputError"

const CompanyAddress = ({ register, error }) => {
  const { t } = useTranslation()

  return (
    <>
      <Input
        error={error}
        register={register('headquarterAddress', {
          required: t('mainReporting:form.mandatory'),
        })}
        label={t('mainReporting:form.companyAddress.label')}
        placeholder={t('mainReporting:form.companyAddress.placeholder')}
      />
      <InputError error={error} />
    </>
  )
}

export default CompanyAddress
